// import { jsPDF } from "jspdf";

// const ReceiptGenerator = ({ order }) => {
//   const generatePDF = () => {
//     const doc = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: "a4",
//     });

//     // Constants for layout
//     const pageWidth = 210;
//     const margin = 15;
//     const contentWidth = pageWidth - 2 * margin;
//     const lineHeight = 7;
//     let yPosition = margin;

//     // Helper function to add text with wrapping
//     const addText = (text, x, y, options = {}) => {
//       const fontSize = options.fontSize || 10;
//       const fontStyle = options.fontStyle || "normal";
//       const maxWidth = options.maxWidth || contentWidth;
//       doc.setFont("helvetica", fontStyle);
//       doc.setFontSize(fontSize);
//       doc.text(text, x, y, { maxWidth });
//       return doc.getTextDimensions(text, { fontSize, maxWidth }).h;
//     };

//     // Header: HelpNao
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(20);
//     doc.setTextColor(0, 102, 204); // Blue color
//     doc.text("HelpNao", margin, yPosition);
//     yPosition += 10;

//     // Reset font for body
//     doc.setTextColor(0, 0, 0);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);

//     // Order Details (Left Side)
//     addText(`Invoice Order#: ${order.order_number}`, margin, yPosition);
//     yPosition += lineHeight;
//     addText(
//       `Placed Order Date: ${new Date(order.created_at).toLocaleDateString()}`,
//       margin,
//       yPosition
//     );
//     yPosition += lineHeight;
//     addText(
//       `Service Delivered Date: ${
//         order.date ? new Date(order.date).toLocaleDateString() : "TBD"
//       }`,
//       margin,
//       yPosition
//     );
//     yPosition += lineHeight;
//     addText(`Service Delivered Time: ${order.time}`, margin, yPosition);
//     yPosition += lineHeight;
//     addText(`Order Status: ${order.status}`, margin, yPosition);
//     yPosition += 10;

//     // Divider Line
//     doc.setLineWidth(0.5);
//     doc.line(margin, yPosition, margin + contentWidth, yPosition);
//     yPosition += 5;

//     // User and Servitor Details (Side by Side)
//     const userDetails = [
//       `Name: ${
//         order.User
//           ? `${order.User.FirstName} ${order.User.LastName}`
//           : "Unknown"
//       }`,
//       `Mobile: ${order.User ? `0${order.User.mobile}` : "Unknown"}`,
//       `City: ${order.usercity || order.City}`,
//       `Address: ${order.useraddress || order.Address}`,
//     ];

//     const servitorDetails = order.Servitor
//       ? [
//           `Name: ${order.Servitor.FirstName} ${order.Servitor.LastName}`,
//           `Mobile: ${order.Servitor.mobile ? `0${order.Servitor.mobile}` : "N/A"}`,
//           `NID: ${order.Servitor.NID || "N/A"}`,
//           `Address: ${order.Servitor.city || "No city"}`,
//         ]
//       : ["Name: N/A", "Mobile: N/A", "NID: N/A", "Address: N/A"];

//     // Headers
//     addText("User Details", margin, yPosition, { fontStyle: "bold" });
//     addText("Servitor Details", margin + contentWidth / 2, yPosition, {
//       fontStyle: "bold",
//     });
//     yPosition += lineHeight;

//     // Vertical Divider
//     doc.line(
//       margin + contentWidth / 2,
//       yPosition - lineHeight,
//       margin + contentWidth / 2,
//       yPosition + lineHeight * 4
//     );

//     // Details
//     userDetails.forEach((line, index) => {
//       addText(line, margin, yPosition, { maxWidth: contentWidth / 2 - 5 });
//       addText(servitorDetails[index], margin + contentWidth / 2 + 5, yPosition, {
//         maxWidth: contentWidth / 2 - 5,
//       });
//       yPosition += lineHeight;
//     });

//     yPosition += 10;

//     // Service Details
//     addText("Service Details", margin, yPosition, {
//       fontStyle: "bold",
//       fontSize: 12,
//     });
//     yPosition += lineHeight;

//     const serviceName = order.Service
//       ? order.Service.services_name
//       : order.service_name || "Unknown";
//     addText(`Service: ${serviceName}`, margin, yPosition);
//     yPosition += lineHeight;

//     const serviceFields = {
//       "Home Cleaning": [
//         { key: "bed", label: "Bedroom" },
//         { key: "kitchen", label: "Kitchen" },
//         { key: "dra_din", label: "Drawing-Dining" },
//         { key: "bath", label: "Bathroom" },
//         { key: "balcony", label: "Balcony Cleaning" },
//         { key: "window_grill", label: "Window & Grill Cleaning" },
//         { key: "furniture_cleaning", label: "Furniture Cleaning" },
//         { key: "cloth", label: "Cloths" },
//         { key: "dish", label: "Dishes" },
//       ],
//       Electrician: [
//         { key: "Fan_in_un", label: "Fan Install" },
//         { key: "Light_in_un", label: "Light Install" },
//         { key: "Fan_repair", label: "Fan Repair" },
//         { key: "Light_repair", label: "Light Repair" },
//         { key: "Switch_repair", label: "Switch Repair" },
//         { key: "MCB_service", label: "MCB Service" },
//         { key: "MDB_service", label: "MDB Service" },
//         { key: "Fan_regulator_in_un", label: "Regulator Install" },
//         { key: "Fan_regulator_repair", label: "Regulator Repair" },
//         { key: "Socket_in_un", label: "Socket Install" },
//         { key: "Socket_repair", label: "Socket Repair" },
//         { key: "Circuit_breaker_repair", label: "Breaker Repair" },
//         { key: "New_wiring_point", label: "New Wiring Point" },
//         { key: "Full_wiring", label: "Full Wiring", format: (v) => v ? "Yes" : "No" },
//         { key: "Electrical_checkup", label: "Electrical Checkup", format: (v) => v ? "Yes" : "No" },
//       ],
//       Plumber: [
//         { key: "Toilet_in", label: "Toilet Install" },
//         { key: "Faucet_in", label: "Faucet Install" },
//         { key: "Sink_in", label: "Sink Install" },
//         { key: "Dishwasher_in", label: "Dishwasher Install" },
//         { key: "Leak_repair", label: "Leak Repair" },
//         { key: "Faucet_repair", label: "Faucet Repair" },
//         { key: "Toilet_repair", label: "Toilet Repair" },
//         { key: "Shower_repair", label: "Shower Repair" },
//         { key: "Drain_cleaning", label: "Drain Cleaning" },
//         { key: "pipe_cleaning", label: "Pipe Cleaning" },
//         { key: "tank_cleaning", label: "Tank Cleaning" },
//         { key: "issue_checkup", label: "Issue Checkup", format: (v) => v ? "Yes" : "No" },
//       ],
//     };

//     const fields = serviceFields[order.service_name] || [];
//     fields.forEach(({ key, label, format }) => {
//       const value = order[key];
//       if (value || value === 0) {
//         const displayValue = format ? format(value) : value;
//         addText(`${label}: ${displayValue}`, margin + 5, yPosition);
//         yPosition += lineHeight;
//       }
//     });

//     yPosition += lineHeight;
//     addText(`Total Amount: ${order.price} tk`, margin, yPosition, {
//       fontStyle: "bold",
//     });

//     // Footer
//     yPosition = 270; // Fixed position for footer
//     doc.setFontSize(8);
//     doc.setTextColor(100, 100, 100);
//     doc.text(
//       "Thank you for choosing HelpNao! For support, contact us at support@HelpNao.com or +880123456789.",
//       pageWidth / 2,
//       yPosition,
//       { align: "center" }
//     );

//     // Save PDF
//     doc.save(`HelpNao_Receipt_${order.order_number}.pdf`);
//   };

//   generatePDF();
//   return null;
// };

// export default ReceiptGenerator;




























// // ReceiptGenerator.jsx
// import React, { useEffect, useRef } from "react";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import InvoiceTemplate from "./InvoiceTemplate";

// const ReceiptGenerator = ({ order, onFinish }) => {
//   const invoiceRef = useRef();
//   const hasGeneratedRef = useRef(false);

//   useEffect(() => {
//     const generatePDF = async () => {
//       if (!invoiceRef.current) return;

//       try {
//         // 1) Capture the DOM node as a canvas
//         const canvas = await html2canvas(invoiceRef.current, {
//           scale: 2,
//           useCORS: true,
//         });
//         const imgData = canvas.toDataURL("image/png");

//         // 2) Create an A4 jsPDF
//         const pdf = new jsPDF("p", "mm", "a4");
//         const pageWidth = pdf.internal.pageSize.getWidth();   // 210
//         const pageHeight = pdf.internal.pageSize.getHeight(); // 297

//         // 3) Determine the image's pixel dimensions
//         const imgProps = pdf.getImageProperties(imgData);
//         const imgWidthPx = imgProps.width;
//         const imgHeightPx = imgProps.height;

//         // 4) Compute scale so it fits in A4 with 10 mm margin on all sides
//         const marginMM = 10;
//         const maxWidthMM = pageWidth - 2 * marginMM;
//         const maxHeightMM = pageHeight - 2 * marginMM;

//         // Convert canvas px → mm by ratio (assuming 1px ≈ 0.264583 mm at 96 DPI)
//         // But jsPDF.addImage will auto-scale if we pass widths in mm relative to px
//         // So we simply find a uniform scale factor in “PDF units”:
//         const scaleX = maxWidthMM / imgWidthPx;
//         const scaleY = maxHeightMM / imgHeightPx;
//         const scale = Math.min(scaleX, scaleY);

//         // Final image dimensions in mm:
//         const pdfImgWidth = imgWidthPx * scale;
//         const pdfImgHeight = imgHeightPx * scale;

//         // 5) Center vertically & horizontally
//         const xOffset = (pageWidth - pdfImgWidth) / 2;
//         const yOffset = (pageHeight - pdfImgHeight) / 2;

//         // 6) Add the image and save
//         pdf.addImage(
//           imgData,
//           "PNG",
//           xOffset,
//           yOffset,
//           pdfImgWidth,
//           pdfImgHeight
//         );
//         pdf.save(`HelpNao_Receipt_${order.order_number}.pdf`);
//       } catch (err) {
//         console.error("Error generating PDF:", err);
//       } finally {
//         if (typeof onFinish === "function") onFinish();
//       }
//     };

//     if (!hasGeneratedRef.current && invoiceRef.current) {
//       hasGeneratedRef.current = true;
//       generatePDF();
//     }
//     // generatePDF();
//   }, [order, onFinish]);
  

//   // Render invoice off-screen
//   return (
//     <div style={{ position: "absolute", top: -9999, left: -9999 }}>
//       <InvoiceTemplate order={order} ref={invoiceRef} />
//     </div>
//   );
// };

// export default ReceiptGenerator;












// ***** New Updated (16-oct-2025) ***** //

import React, { useEffect, useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import InvoiceTemplate from "./InvoiceTemplate";

const ReceiptGenerator = ({ order, onFinish }) => {
  const invoiceRef = useRef();
  const hasGeneratedRef = useRef(false);

  useEffect(() => {
    const generatePDF = async () => {
      if (!invoiceRef.current) return;

      try {
        // --- Page + margins (mm) ---
        const pageFormat = "a4";
        const marginMM = 10;

        // Create a temp pdf to read exact page size in mm
        const probe = new jsPDF({ orientation: "p", unit: "mm", format: pageFormat });
        const pageWidthMM = probe.internal.pageSize.getWidth();
        const pageHeightMM = probe.internal.pageSize.getHeight();
        const maxWidthMM = pageWidthMM - 2 * marginMM;
        const maxHeightMM = pageHeightMM - 2 * marginMM;

        // --- Adaptive target DPI for crispness ---
        // 210–220 DPI gives sharp text without huge files
        const targetDPI = 316;

        // convert our target drawing box into pixels we want to fill
        const targetImgWidthPx  = Math.round((maxWidthMM  / 25.4) * targetDPI);
        const targetImgHeightPx = Math.round((maxHeightMM / 25.4) * targetDPI);

        // actual element size (CSS pixels)
        const el = invoiceRef.current;
        const elWidthPx  = Math.max(el.scrollWidth, el.clientWidth);
        const elHeightPx = Math.max(el.scrollHeight, el.clientHeight);

        // scale so the shorter side matches our target box but respects aspect
        const scaleX = targetImgWidthPx  / elWidthPx;
        const scaleY = targetImgHeightPx / elHeightPx;
        // we only need to guarantee width coverage; height will fit by image scaling
        // let scale = Math.min(Math.max(scaleX, scaleY), 3.0); // clamp 1.0–3.0
        let scale = Math.max(1.0, Math.min(3.0, Math.max(scaleX, scaleY)));

        // Render high-quality canvas
        const canvas = await html2canvas(el, {
          scale,
          useCORS: true,
          allowTaint: false,
          backgroundColor: "#ffffff",
          imageTimeout: 15000,
          removeContainer: true,
          // boost quality a bit on some browsers
          onclone: (doc) => {
            const c = doc.querySelector(".receipt-container");
            if (c) {
              c.style.transform = "translateZ(0)"; // promote to its own layer
            }
          },
        });

        // Primary encode: high quality JPG
        let quality = 0.9;
        let imgData = canvas.toDataURL("image/jpeg", quality);

        // If > ~2.5 MB, reduce quality a notch (adaptive)
        const dataBytes = Math.ceil((imgData.length - "data:image/jpeg;base64,".length) * 0.75);
        if (dataBytes > 2.5 * 1024 * 1024) {
          quality = 0.82;
          imgData = canvas.toDataURL("image/jpeg", quality);
        }

        // Build final PDF (with compression)
        const pdf = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: pageFormat,
          compressPdf: true,
        });

        // image native px size
        const imgProps = pdf.getImageProperties(imgData);
        const imgWpx = imgProps.width;
        const imgHpx = imgProps.height;

        // scale uniformly to fit our content box in mm
        const scalePdfX = maxWidthMM / imgWpx;
        const scalePdfY = maxHeightMM / imgHpx;
        const pdfScale  = Math.min(scalePdfX, scalePdfY);

        const pdfImgW = imgWpx * pdfScale;
        const pdfImgH = imgHpx * pdfScale;

        const x = (pageWidthMM - pdfImgW) / 2; // centered horizontally
        const y = marginMM;                     // fixed top margin (no big gaps)

        pdf.addImage(imgData, "JPEG", x, y, pdfImgW, pdfImgH);
        pdf.setProperties({
          title: `HelpNao Receipt ${order.order_number}`,
          author: "HelpNao",
          subject: "Service Receipt",
        });
        pdf.save(`HelpNao_Receipt_${order.order_number}.pdf`);
      } catch (err) {
        console.error("Error generating PDF:", err);
      } finally {
        if (typeof onFinish === "function") onFinish();
      }
    };

    if (!hasGeneratedRef.current && invoiceRef.current) {
      hasGeneratedRef.current = true;
      generatePDF();
    }
  }, [order, onFinish]);

  // Off-screen render (keeps UI clean)
  return (
    <div style={{ position: "absolute", top: -9999, left: -9999 }}>
      <InvoiceTemplate order={order} ref={invoiceRef} />
    </div>
  );
};

export default ReceiptGenerator;
